// src/pages/AutonomoFactsForm.js
//
// Collects AutonomoFacts — person-level RETA/autónomo status. Distinct from
// the self-employment IncomeItem fields (activity_classification,
// activity_started_this_year, withholding_ratio), which are per-activity and
// live in IncomeCard.js's SelfEmploymentExpenseSection instead. See the
// IncomeItem vs. AutonomoFacts split documented in calculatorTypes.ts.
//
// v1a scope: no contribution-base picker. selected_contribution_base stays
// null (engine defaults to band minimum) — see autonomoCuota.ts. This form
// only collects the facts needed to run that default correctly.
//
// registered_reta_last_2_years / previously_used_tarifa_plana are both plain
// yes/no — no 'unsure' option. Both are facts about the person's own
// history, not judgment calls, so we ask directly rather than offering an
// escape hatch. previously_used_tarifa_plana only appears once the first
// question resolves to "No" — if they WERE registered in the last 2 years
// they're already ineligible regardless of the older history.

import React from 'react'
import { Field, Select } from './CalculatorFields'
import {
  AUTONOMO_QUESTIONS,
  AUTONOMO_TYPE_OPTIONS,
  YES_NO_OPTIONS,
  boolToOptionValue,
  optionValueToBool,
} from '../hooks/autonomoFactsConfig'

export default function AutonomoFactsForm({ facts, onChange }) {
  function update(patch) {
    onChange({ ...facts, ...patch })
  }

  return (
    <div className="cal-autonomo-facts u-stack-lg">
      <Field label={AUTONOMO_QUESTIONS.type}>
        <Select
          value={facts.autonomo_type}
          onChange={v => update({ autonomo_type: v })}
          options={AUTONOMO_TYPE_OPTIONS}
        />
      </Field>

      <Field
        label={AUTONOMO_QUESTIONS.reta}
        helper="This determines whether the reduced flat-rate contribution (tarifa plana) can apply."
      >
        <Select
          value={boolToOptionValue(facts.registered_reta_last_2_years)}
          onChange={v => update({
            registered_reta_last_2_years: optionValueToBool(v),
            // Clear the follow-up if they flip back to "Yes" — it's no
            // longer asked or relevant once this resolves to true.
            previously_used_tarifa_plana: v === 'no' ? facts.previously_used_tarifa_plana : null,
          })}
          options={YES_NO_OPTIONS}
        />
      </Field>

      {facts.registered_reta_last_2_years === false && (
        <Field
          label={AUTONOMO_QUESTIONS.tarifa}
          helper="A longer 3-year window applies if you previously used the flat rate — this determines whether that extended window rules you out."
        >
          <Select
            value={boolToOptionValue(facts.previously_used_tarifa_plana)}
            onChange={v => update({ previously_used_tarifa_plana: optionValueToBool(v) })}
            options={YES_NO_OPTIONS}
          />
        </Field>
      )}
    </div>
  )
}